export class ClipboardFeedbackOwner {
  private generation = 0
  private timer: ReturnType<typeof globalThis.setTimeout> | null = null

  constructor(
    private readonly schedule: typeof globalThis.setTimeout = globalThis.setTimeout,
    private readonly clear: typeof globalThis.clearTimeout = globalThis.clearTimeout,
  ) {}

  invalidate(): void {
    this.generation += 1
    if (this.timer !== null) {
      this.clear(this.timer)
      this.timer = null
    }
  }

  async copy(
    text: string,
    writeText: (value: string) => Promise<void>,
    setCopied: (copied: boolean) => void,
  ): Promise<void> {
    this.invalidate()
    const generation = this.generation
    await writeText(text)
    if (generation !== this.generation) return
    setCopied(true)
    this.timer = this.schedule(() => {
      if (generation === this.generation) setCopied(false)
      this.timer = null
    }, 1_500)
  }
}
